<template>
  <view class="result-wrap">
    <view class="result-container">
      <view class="reward-content">
        <view class="reward-item" wx:for= "{{rewardArr}}" wx:key="index">
          <text class="unit-title">{{item.couponType}}</text>
          <view class="number-place">
            <view class="{{item.className}}">{{ item.coupon.max_benefit_capacity.value}}</view>
            <text class="unit">{{item.coupon.max_benefit_capacity.unit}}</text>
          </view>
          <view class="text-place">
            <view class="coupon-name">{{ item.coupon.name }}</view>
            <view class="coupon-text">{{ item.coupon.usage_limit }}</view>
            <view class="coupon-text">{{ item.coupon.valid_period }}</view>
          </view>
          <image class="to-use" src="{{btnImg}}" bindtap="useCoupon(item)"/>
        </view>
        <view class="result-btn" bindtap="toUse">{{ indexConfig.button.gotoText }}</view>
        <image class="bottom-wrap" src="https://ut-static.udache.com/webx/ut/-NYe0Tg5-Uatr5llcvA5L.png"/>
      </view>
    </view>
    <image wx:if="{{bannerInfo.image}}" src="{{bannerInfo.image}}" mode="widthFix" class="result-banner" bindtap="jumpLink"/>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { gotoLink, getCouponTypeTip } from '../../lib/utils'
import {
  sendXspmClick,
  sendXspmScan,
  trackEvent
} from '@didi/webx-js'
  createComponent({
    properties: {
      rewardList: Array,
      config: Object,
      indexConfig: Object,
    },
    data: {
        btnImg: 'https://ut-static.udache.com/webx/ut/0SornJmp-xyg5HHtbowql.png',
        xspmInfo: {
          a: '',
          b: 'result-page',
          c: 'c1120',
          d: '',
        },
    },
    computed: {
      rewardArr() {
        return this.rewardList.map(item => {
          const valueStr = String(item.coupon?.max_benefit_capacity?.value)
          return {
            ...item,
            className: `digit-${valueStr.length > 3 ? 3 : valueStr.length}`,
            couponType: getCouponTypeTip(item.coupon.type),
          }
        })
      },
      bannerInfo() {
        return this.config?.banner || {}
      },
    },
    attached() {
      trackEvent('userteam_ddlm_couponlist_pg_sw', '结果页曝光')
      this.bannerInfo.image && sendXspmScan({}, this.xspmInfo)
    },
    methods: {
      jumpLink() {
        const link = this.bannerInfo.link
        trackEvent('userteam_ddlm_couponlist_banner_ck', '结果页banner点击')
        sendXspmClick({}, this.xspmInfo)
        gotoLink(link, this.xspmInfo)
      },
      toUse() {
        this.triggerEvent('toUseCoupon')
      },
      useCoupon(item) {
        if (!item.link) {
          return
        }
        this.triggerEvent('couponToUse', { item })
      },
    },
  })
</script>


<style lang="stylus" scoped>
 // gift也在使用，具体文字见 gift/form.js
@font-face {
  font-family: MF-YuanHei-Regular-self
  src: url('https://ut-static.udache.com/webx/ut/U5woePCABf6dcanedQgUC.ttf')
}

@font-face {
  font-family: UniSansHeavyItalic-self
  src: url('https://ut-static.udache.com/webx/ut/vmQnYmHW1SxSO7AHH9iWh_UniSansHeavyItalic.ttf')
}
.result-wrap
  display: flex
  flex-direction: column
  align-items: center
  width: 750rpx
  min-height: 100vh
  padding-top 126rpx
  background: url('https://ut-static.udache.com/webx/ut/0-YMc4YxQN0BJzMfMTTSp.png')
  background-repeat: no-repeat
  background-size: 100vw auto
  background-color: RGB(255, 155, 50)
  box-sizing border-box
.result-container
  position: relative
  display flex
  justify-content: center
  width: 710rpx
  height: 920rpx
  background: url('https://ut-static.udache.com/webx/ut/6b-fvrswY9u4ouoe7C7mg.png') center no-repeat
  background-size: 100% 100%
.reward-content
  width: 686rpx
  height: 651.71rpx
  margin-top: 112.29rpx
  overflow: scroll
.reward-item:first-child
  margin-top: 30.71rpx
.reward-item
  position: relative
  display: flex
  justify-content: flex-start
  align-items: center
  width: 670rpx
  height: 207rpx
  background: url('https://ut-static.udache.com/webx/ut/Z3vOO0mh_oS2jV91TyZ2w.png') center no-repeat
  background-size: 100% 100%
.unit-title
  position: absolute
  top: 8.47rpx
  left: 37rpx
  color: #FFFFFF
  font-size: 24rpx
  font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self
  font-weight 600
.number-place
  position: relative
  display: flex
  justify-content: space-around
  align-items: center
  width: 148rpx
  height: 144rpx
  margin-left: 34rpx
  margin-right: 33.88rpx
  margin-top: -28rpx;
.digit-1, .digit-2, .digit-3
  color: #F86500
  font-weight: 900
  font-family: UniSansHeavyItalic, UniSansHeavyItalic-self
.digit-1
  font-size: 100rpx
.digit-2
  font-size: 80rpx
.digit-3
  font-size: 58rpx
.unit
  position: absolute
  right: -10rpx
  bottom: 48rpx
  font-size: 28rpx
  font-family: PingFangSC-Medium
  font-weight 600
  color: RGB(255, 102, 0)
.text-place
  margin-top: 86rpx;
  width: 225rpx
  height: 100%
.coupon-name
  color: #4D4C4C
  line-height: 24rpx
  font-weight: 500
  font-family: PingFangSC-Medium
  font-size: 24rpx
  letter-spacing: 0
  margin-bottom: 18rpx
.coupon-text
  color: #878787
  font-size: 18rpx
  line-height: 1
  font-family: PingFangSC-Regular
  letter-spacing: 0
  margin-bottom: 10rpx
.to-use
  position: absolute
  right: 35rpx
  top: 61rpx
  width: 162rpx
  height: 60rpx
.bottom-wrap
  position: absolute
  bottom: 0
  left: 0
  width: 710rpx
  height: 260rpx
.result-btn
  background: url('https://ut-static.udache.com/webx/ut/HhErpdyuGReqLaeY0Hs1j.png') center no-repeat
  background-size: 100% 100%
  width 600rpx
  height 140rpx
  position absolute
  bottom 32rpx
  z-index 2
  font-family PingFangSC-Semibold
  font-weight bold
  font-size: 48rpx;
  color: #FFFFFF;
  letter-spacing: 2.88rpx;
  text-align: center;
  line-height 112rpx
  left 50%
  transform translateX(-50%)
.bottom-click
  position:absolute
  left: 336rpx
  bottom: 48rpx
  width: 38rpx
  height: 38rpx
.result-banner
  width: 710rpx
  margin-top: 40rpx
  margin-bottom: 102rpx
</style>
